import { call, put } from "redux-saga/effects";
import { setNewNotifications, setOldNotifications } from "../../entities/notifications";
import { requestGetUserNewNotifications, requestGetUserOldNotifications } from "../requests/notifications";



export function* handleGetUserNewNotifications(action) {
    try {
        const response = yield call(requestGetUserNewNotifications, action.payload);
        const { data } = response;
        yield put(setNewNotifications({ ...data }));
    } catch (error) {
        console.log(error);
    }
}


export function* handleGetUserOldNotifications(action) {
    try {
        const response = yield call(requestGetUserOldNotifications, action.payload);
        const { data } = response;
        yield put(setOldNotifications({ ...data }));
    } catch (error) {
        console.log(error);
    }
}